import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface AuthState {
  isAuthenticated: boolean,
  accessToken: string | null,
  userDetails: any | null,
}



const initialState : AuthState = {
    isAuthenticated: false,
    accessToken: '',
    userDetails: null,
  };

export const authSlice = createSlice({
  name: 'auth',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    userAuthenticated: (state, action) => {
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
    },
    logout: (state) => {
        state.isAuthenticated = false;
        state.accessToken = null;
        state.userDetails = null;
    },
    updateUserDetails: (state , action : PayloadAction<Pick<AuthState, 'userDetails'>>) => {
        state.userDetails = action.payload;
    },
    updateUserDetailLinkedApp: (state , action : PayloadAction<Pick<AuthState, 'userDetails'>>) => {
      state.userDetails.linkedApplications[0] = action.payload;
  },

   
  },
})

export const {  logout , updateUserDetails,updateUserDetailLinkedApp, userAuthenticated } = authSlice.actions

export default authSlice.reducer